import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ResultDetailCard from '@Components/Results/common/ResultDetailCard';

function DocumentAbstract({ abstractText, closeClick }) {
  return (
    <ResultDetailCard id="abstractExpanded-content" title="Abstract" closeDataE2e="abstract-button-close" onClose={closeClick}>
      <InnerHTML tag="p" className="u-els-font-size-base u-els-line-height-default" html={abstractText} />
    </ResultDetailCard>
  );
}

DocumentAbstract.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentAbstract;
